import React from 'react'
import './impressum.scss'
function Impressum() {
  const email = "info@test.de";
  const tel = "015114766666";
  const city = '41749 Viersen';
  const street = 'Spenglerstrasse 10';
  return (
    <div className='impressum_container'>
    <div className='impressum'>
      <h1>Impressum</h1>
        <span>
            <div>
              <p>Nassco Transport GmbH</p>
              <p>Zossener Chaussee 38</p>
              <p>15838 Am Mellensee, Berlin</p>
              <p>Handelsregister: HRB 40326 P</p>
              <p>Registergericht: Amtsgericht Potsdam</p>
            </div>

            <div>
                <b>Vertreten durch:</b>
                <b>GF Sami Jallous </b>
                <p>Zossener Chaussee 38</p>
                <p>15838 Am Mellensee</p>
            </div>

            <div>
              <b>Kontakt</b>
              <p>Telefon: 015114766666</p>
              <p>E-Mail: info@nassco-m.de</p>

            </div>
            <div>
              <b>Umsatzsteuer-ID</b>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
              <p>DE453994453</p>

            </div>

            <div>
              <b>Angaben zur Berufs­haftpflicht­versicherung</b>
              <b>Name und Sitz des Versicherers:</b>
              <p>Allianz</p>

            </div>

            <div>
              <b>Geltungsraum der Versicherung:</b>
              <p>EU</p>
            </div>

            <div>
              <b>Redaktionell verantwortlich</b>
              <b>Sami Jallous</b>    
              <p>Zossener Chaussee 38</p>
              <p>15838 Am Mellensee</p>
            </div>

            <div>
              <b>EU-Streitschlichtung</b>
              <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
              <b>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</b>
              <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
              <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
            </div>
        </span>
        
    </div>
     
       
    </div>
  )
}

export default Impressum